import {
  ADD_EVENT_INFO,
  ADD_EVENT_INFO_FAILED,
  ADD_EVENT_INFO_SUCCESS,
  GET_EVENT_INFO,
  GET_EVENT_INFO_FAILED,
  GET_EVENT_INFO_LIST,
  GET_EVENT_INFO_LIST_FAILED,
  GET_EVENT_INFO_LIST_SUCCESS,
  GET_EVENT_INFO_SUCCESS,
  GET_RSVP_BOOKED_SPOTS,
  GET_RSVP_BOOKED_SPOTS_FAILED,
  GET_RSVP_BOOKED_SPOTS_SUCCESS,
  GET_RSVP_WEBPAGE_CONFIG,
  GET_RSVP_WEBPAGE_CONFIG_FAILED,
  GET_RSVP_WEBPAGE_CONFIG_SUCCESS,
  RESET_EVENT_INFO,
  RESET_EVENT_INFO_LIST,
  UPDATE_EVENT_INFO,
  UPDATE_EVENT_INFO_FAILED,
  UPDATE_EVENT_INFO_SUCCESS,
} from "./actionTypes"

export const addEventInfo = props => ({
  type: ADD_EVENT_INFO,
  payload: props,
})

export const addEventInfoSuccess = response => ({
  type: ADD_EVENT_INFO_SUCCESS,
  payload: response,
})

export const addEventInfoFailed = error => ({
  type: ADD_EVENT_INFO_FAILED,
  payload: error,
})

export const getEventInfo = params => ({
  type: GET_EVENT_INFO,
  payload: params,
})

export const getEventInfoSuccess = response => ({
  type: GET_EVENT_INFO_SUCCESS,
  payload: response,
})

export const getEventInfoFailed = error => ({
  type: GET_EVENT_INFO_FAILED,
  payload: error,
})

export const resetEventInfo = () => ({
  type: RESET_EVENT_INFO,
  payload: {},
})

export const updateEventInfo = params => ({
  type: UPDATE_EVENT_INFO,
  payload: params,
})

export const updateEventInfoSuccess = () => ({
  type: UPDATE_EVENT_INFO_SUCCESS,
  payload: {},
})

export const updateEventInfoFailed = error => ({
  type: UPDATE_EVENT_INFO_FAILED,
  payload: error,
})

export const getRsvpWebpageConfig = params => ({
  type: GET_RSVP_WEBPAGE_CONFIG,
  payload: params,
})

export const getRsvpWebpageConfigSuccess = response => ({
  type: GET_RSVP_WEBPAGE_CONFIG_SUCCESS,
  payload: response,
})

export const getRsvpWebpageConfigFailed = error => ({
  type: GET_RSVP_WEBPAGE_CONFIG_FAILED,
  payload: error,
})

export const getRsvpBookedSpots = params => ({
  type: GET_RSVP_BOOKED_SPOTS,
  payload: params,
})

export const getRsvpBookedSpotsSuccess = response => ({
  type: GET_RSVP_BOOKED_SPOTS_SUCCESS,
  payload: response,
})

export const getRsvpBookedSpotsFailed = error => ({
  type: GET_RSVP_BOOKED_SPOTS_FAILED,
  payload: error,
})

export const getEventInfoList = params => ({
  type: GET_EVENT_INFO_LIST,
  payload: params,
})

export const getEventInfoListSuccess = response => ({
  type: GET_EVENT_INFO_LIST_SUCCESS,
  payload: response,
})

export const getEventInfoListFailed = error => ({
  type: GET_EVENT_INFO_LIST_FAILED,
  payload: error,
})

export const resetEventInfoList = () => ({
  type: RESET_EVENT_INFO_LIST,
  payload: {},
})
